// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"ViewPriceListPage_buttonContainer__18TC6"};